import React from "react";
import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="footer-container">
      <div>© 2022 All rights reserved</div>
    </footer>
  );
};
